import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LanguageService } from '../../../services/language.service';
/**
 * Wallet Settings Component
 */
let WalletSettingsComponent = class WalletSettingsComponent {
    constructor(httpClient, sanitizer, themeService, router, languageService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.router = router;
        this.languageService = languageService;
        this.backColor = '';
        this.accentColor = '';
        this.mainColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.textColor = '';
        this.errorColor = '';
        this.successColor = '';
        this.secondaryColor = '';
        this.linkColor = '';
        this.inputBackColor = '';
        if (!localStorage.getItem('user')) {
            this.router.navigateByUrl('');
        }
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.secondaryColor = this.themeService.getStyleAttribute('secondary_text_color');
        });
    }
    ngOnInit() {
    }
};
WalletSettingsComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: Router },
    { type: LanguageService }
];
WalletSettingsComponent = __decorate([
    Component({
        selector: 'ecd-wallet-settings',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./wallet-settings.component.html")).default
    })
], WalletSettingsComponent);
export { WalletSettingsComponent };
